import Configuration from '../Configuration';

const account = Configuration.get('gtag-conversion.account', null);
const events  = Configuration.get('gtag-conversion.events', []);

/** Generates the script URL for `gtag.js` */
function scriptUrlForAccount() {
    return `https://www.googletagmanager.com/gtag/js?id=${account}`;
}

/** The `gtag.js` script element handle */
let scriptElement = null;

/** Adds the `gtag.js` script to the document */
function addGtagScript() {
    if (scriptElement) return false;

    const url = scriptUrlForAccount(account);

    scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.setAttribute('async', 'true');
    scriptElement.setAttribute('src', url);

    document.documentElement.firstChild.appendChild(scriptElement);
    return true;
}

/** Create `window.dataLayer` to communicate with `gtag.js` */
function addDataLayer() {
    window.dataLayer = window.dataLayer || [];
    return true;
}

/** Add an item to `window.dataLayer` */
function gtag() {
    if (!window.dataLayer) return false;

    window.dataLayer.push(arguments);
    return true;
}

/** Parse the cookie string (header or 'document.cookie') */
function parseCookie(cookieStr) {
    return cookieStr.split(';') // Split string into key/values
        .map(s => s.split('=')  // Split keys from values
            .map(t => t.trim()) // Trim keys and values
        )
        .filter(a => a.length > 0)   // Filter empty
        .reduce((cookies, raw) => ({ // Add key: value to cookies map
            ...cookies,
            [decodeURIComponent(raw[0])]: raw[1] ?? ''
        }), {});
}

/** Checks whether conversions should be enabled */
function checkConversionsEnabled() {
    const hostname = document.location.hostname;

    // Connect / Calculator and Simulator: disabled
    if (hostname.match(/^(simulator|connect)\.bluekit\./)) {
        return false;
    }

    // Bluekit Websites: check presence of CMS's consent cookie
    if (hostname.match(/(^|\.)bluekit\./)) {
        const consentCookie  = 'omCookieConsent';
        const consentPattern = /^group-(\d)+\.1,dismiss/;
        const cookies = parseCookie(document.cookie);

        if (!cookies[consentCookie]) return false;

        return cookies[consentCookie].match(consentPattern) !== null;
    }

    // Default: disabled
    return false;
}

/** Set to true when the initialization is done */
let initialized = false;

/**
 * Initialize GTag Conversions: create the `dataLayer`, async-load the `gtag.js` script
 * @returns `true` if initialization was successful (configuration is not corrupted)
 */
export function initialize() {
    if (initialized) return true;
    if (!account) return false;
    if (!checkConversionsEnabled()) return false;

    initialized = true;

    addDataLayer();
    addGtagScript();

    gtag('js', new Date());
    gtag('config', account);

    return true;
}

/**
 * Register a Conversion for an `event` identifier
 * @param {string} event The event identifier to match against the `events` map in `configuration.js`
 * @returns `true` if the conversion was properly recorded in the `dataLayer`
 */
export function conversion(event) {
    if (!(event in events)) return false;
    return initialize() && gtag('event', 'conversion', { send_to: events[event] });
}

/** Vue.js Component Mixin */
export const Mixin = {
    created() {
        initialize();
    },
    methods: {
        conversion,
    },
}
